export const SHIFT_DRAFT_ID_PREFIX = 'draft-';

export function isShiftDraftId(id) {
    return String(id || '').startsWith(SHIFT_DRAFT_ID_PREFIX);
}

/**
 * Local draft shift opened from a calendar slot click.
 * Not persisted until the user saves the form.
 */
export function buildShiftDraftFromSlot({
    applicationTypeId,
    start,
    end,
    sectorId,
    activityId,
}) {
    if (!applicationTypeId || !sectorId || !start || !end)
        return null;

    const draft = {
        id: `${SHIFT_DRAFT_ID_PREFIX}${Date.now()}`,
        isDraft: true,
        application_type_id: applicationTypeId,
        start_at: start,
        stop_at: end,
        sector_id: sectorId,
        nb_volunteers: 0,
        nb_assigned: 0,
        status: 'new',
    };
    if (activityId)
        draft.activity_id = activityId;
    return draft;
}
